$('.hub-image-carousel').slick({
  fade: true,
  dots: false,
  arrows: true,
  adaptiveHeight: true,
  autoplay: true,
});
